import { fetcher } from "../fetcher"

type TransactionsTransferAttachmentApiResponse = {
  fileContent: string
  fileName: string
}

const blobToBase64 = (blob: Blob) => {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise<string>((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result as string)
    }
  })
}

export function useTransactionTransferAttachment() {
  return {
    fetch: async (
      transferId: string,
      attachmentId: string
    ): Promise<TransactionsTransferAttachmentApiResponse> => {
      const response = await fetcher(
        `/Attachment/Transfer/${transferId}/File/${attachmentId}`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseBlob = await response.blob()
      const fileContent = (await blobToBase64(responseBlob)).split(",")[1]
      return {
        fileContent,
        fileName: attachmentId,
      }
    },
  }
}
